




















import { Vue, Prop, Watch, Component } from "vue-property-decorator";
@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue {

    @Prop( { type: String } )
    public Titulo: string;

    @Prop( { type: String } )
    public Valor: string;

    @Prop( { type: String } )
    public Icono: string;

    @Prop( { type: Boolean } )
    public br: boolean;

    @Prop( { type: Boolean } )
    public Cargando: boolean;

    @Prop( { type: Boolean } )
    public small: boolean;

    @Prop( { type: Boolean, default: true } )
    public normal: boolean;

    @Prop( { type: Boolean, default: false } )
    public divider: boolean;

    @Prop( { type: Boolean } )
    public large: boolean;


    @Prop( { type: Boolean } )
    public left: boolean;

    get FontSize(): string {
        if ( this.small ) return '14px !important;';
        else if ( this.large ) return '18px !important;';
        return '16px !important;';
    }

}
